module.exports = __webpack_public_path__ + "img/download.e46cf531.svg";